import { useNavigate } from "react-router-dom";
import FooterInfo from "./FooterInfo";
import hormwowghradioicon from "./images/newhoremowghradioicon.png";
import { useCallback, useEffect, useRef, useState } from "react";
import background1 from "./images/greenwallpaper2.jpg";
import pastorpic1 from "./images/pstabpic1.jpg";
import streamSignal from "./images/connectsignal.png";
import zionbackground from "./images/best6.jpg";
import { off, onValue, ref } from "firebase/database";
import db, { realtimeDB } from "./Backend";
import { collection, onSnapshot } from "firebase/firestore";
import { Button } from "@mui/material";
import DialogAnnouncement from "./DialogAnnouncement";
import { format } from "date-fns";
import WebrtcAxios from "./fetchApi/WebrtcAxios";
import { HbrBroadcast } from "./MyCustomsvgicons";

const Home = () => {
  const[openAnnouncement,setOpenAnnouncement]=useState(false);
  const[weeklyPrograms,setWeeklyPrograms]=useState([]);
  const[numofusers,setNumofusers]=useState([]);
  const[numofzionusers,setNumofZionUsers]=useState([]);
  const[showMobileMenu,setShowMenu]=useState(false);
  const[openTokenDialog,setOpenTokendialog]=useState(false);
  const[hibernateDialog,sethibernateDialog]=useState(false);
  const [logintries,setLogintries]=useState(4);
  const [adminaccesskey,setadminaccesskey]=useState("");
  const [adminName, setAdminName]=useState("");
  const announcementRef = useRef();
  const navigate = useNavigate();
 
 
  

  
  useEffect(()=>{
    const todayDate = format(new Date(),"yyyy-MM-dd");
    const ziondbRef = ref(realtimeDB,"livefeed");
  const zionusersListeners = onValue(ziondbRef,(snapshot) =>{
      if(snapshot.exists()){
        const items =[];
        snapshot.forEach((childSnapshot) =>{
          const childData = childSnapshot.val();
          if (childData.dateJoined === todayDate) {
            items.push(childData);
          }
        });
        setNumofZionUsers(items);
      };
    });

    const usersDbRef = ref(realtimeDB,"users");
   const usersListener = onValue(usersDbRef,(snapshot) =>{
      if(snapshot.exists()){
        const items2 =[];
        snapshot.forEach((childSnapshot) =>{
          const childData2 = childSnapshot.val();
          if (childData2.dateJoined === todayDate ) {
            items2.push(childData2);
          }
        });
        setNumofusers(items2);
      };
    });

    const collectionRef = collection(db,"programs");
      const unsub = onSnapshot(collectionRef,(snapshot) =>{
          const data = [];
          snapshot.forEach((doc)=>{
            data.push(doc.data());
          });
          setWeeklyPrograms(data);
      });
      return () => {
        unsub();
        off(ziondbRef,zionusersListeners);
        off(usersDbRef,usersListener);
      }
  },[]);
 
    const radioPage =()=>{
        navigate("/onlineradio");
    };
    const gotoBethelCast=()=>{
        navigate("/bethelcast");
    };

    const goToadminDashboard=async(e)=>{
      e.preventDefault();
      try {
       await WebrtcAxios.post("/login", 
          JSON.stringify({userEmail: adminName, pwd: adminaccesskey}),
          {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: false
          }
        );
        navigate("/admindashboard");
      } catch (err){
        if (!err?.response) {
          alert("no server response");
        }else if (err?.response.status === 500) {
          alert("service unavailable at the moment");
          console.log(err);
        }else if (err?.response.status === 409) {
          alert("unauthorized");
        }else if (err?.response.status === 401) {
          alert("The admin name or email or password you entered is incorrect");
        }else{
            alert("an unknown error occurred. report issue to developers");
        }
        console.log(err)
      }
    };

    const handleLoginAttempts=useCallback(()=>{
      if(logintries === 0){
        sethibernateDialog(true);
      }

      const timeid = setTimeout(() => {
        sethibernateDialog(false);
        setLogintries(4);
      }, 4000);

      return ()=>clearTimeout(timeid);
    },[logintries]);

    useEffect(()=>{
      handleLoginAttempts();
    },[handleLoginAttempts]);

    useEffect(()=>{
      const handleCloseDialog=(e)=>{
        try{
          if(!announcementRef.current.contains(e.target)){
            setOpenAnnouncement(false);
          };
        }catch{
          
        }
      };
      document.addEventListener('mousedown',handleCloseDialog);
      return()=>{
        document.removeEventListener('mousedown',handleCloseDialog);
      };
    },[]);


    return ( 
        <div className="home">
                <div className="heading flex-spacebetween" >
                 
                  {!showMobileMenu && 
                      <svg
                      onClick={()=>setShowMenu(true)}
                      id="menu-bar"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      height="30px"
                      width="30px">
                      <path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z" />
                    </svg>
                  } 
                   {showMobileMenu && 
                
                   <svg
                   onClick={()=>setShowMenu(false)}
                   id="cancel-menu-bar"
                   viewBox="0 0 24 24"
                   fill="currentColor"
                   height="30px"
                   width="30px">
                   <path fill="none" d="M0 0h24v24H0z" />
                   <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                 </svg>
                   }
              
                  <nav className="nav-bar">
                    <div style={{position:"relative"}} ref={announcementRef}>
                    <button  onClick={()=>setOpenAnnouncement(prev => !prev)}>Announcement</button>
                              
                          {
                            weeklyPrograms && weeklyPrograms.map(weeklyPrograms =>(
                              <div className={`announcement ${openAnnouncement?'open':'close'}`}  key={weeklyPrograms.timestamp}>
                                       <DialogAnnouncement
                                       timestamp={weeklyPrograms.timestamp}
                                       field1={weeklyPrograms.field1}
                                       field2={weeklyPrograms.field2}
                                       field3={weeklyPrograms.field3}
                                       field4={weeklyPrograms.field4}
                                       field5={weeklyPrograms.field5}
                                       field6={weeklyPrograms.field6}
                                       inputValue1={weeklyPrograms.inputValue1}
                                       inputValue2={weeklyPrograms.inputValue2}
                                       inputValue3={weeklyPrograms.inputValue3}
                                       inputValue4={weeklyPrograms.inputValue4}
                                       inputValue5={weeklyPrograms.inputValue5}
                                       inputValue6={weeklyPrograms.inputValue6}
                                       date={weeklyPrograms.date}
                                       anouncement={weeklyPrograms.anouncement} 
                                      />
                              </div>
                            ))
                          }
                    </div>
                    <button onClick={()=>navigate("/testimonies")}>TestimonyBlog</button>
                    <button onClick={()=>navigate("/report/auth")}>Report</button>
                    <div style={{position:"relative"}}>
                    <button onClick={()=>setOpenTokendialog(prev => !prev)}>Admin</button>
                      {openTokenDialog && !hibernateDialog &&
                        <form className="adminaccessdailog flex-column2" onSubmit={goToadminDashboard}>
                          <h3>Access Token Required</h3>
                          <input type="text" placeholder="username or email" value={adminName} onChange={e => setAdminName(e.target.value)}/>
                          <input type="text" placeholder="access key" value={adminaccesskey} onChange={e => setadminaccesskey(e.target.value)}/>
                          <input type="submit" />
                          {`you have ${logintries} attempts`};
                        </form>
                      }
                      {hibernateDialog && 
                      <div className="adminaccessdailog">
                          <h3>Due to illegal activities the access dialog is temporarily deactivated</h3>
                      </div>}
                    </div>
                    <button onClick={gotoBethelCast}>Bethel Cast</button>
              
                  </nav>
                  {
                    showMobileMenu &&
                    <nav className="nav-bar2">
                         <div style={{position:"relative"}} ref={announcementRef}>
                         <Button onClick={()=>setOpenAnnouncement(prev => !prev)}>Announcement</Button>
                         {
                            weeklyPrograms && weeklyPrograms.map(weeklyPrograms =>(
                              <div className={`announcement ${openAnnouncement?'open':'close'}`}  key={weeklyPrograms.timestamp}>
                                       <DialogAnnouncement
                                      
                                       timestamp={weeklyPrograms.timestamp}
                                       field1={weeklyPrograms.field1}
                                       field2={weeklyPrograms.field2}
                                       field3={weeklyPrograms.field3}
                                       field4={weeklyPrograms.field4}
                                       field5={weeklyPrograms.field5}
                                       field6={weeklyPrograms.field6}
                                       inputValue1={weeklyPrograms.inputValue1}
                                       inputValue2={weeklyPrograms.inputValue2}
                                       inputValue3={weeklyPrograms.inputValue3}
                                       inputValue4={weeklyPrograms.inputValue4}
                                       inputValue5={weeklyPrograms.inputValue5}
                                       inputValue6={weeklyPrograms.inputValue6}
                                       date={weeklyPrograms.date}
                                       anouncement={weeklyPrograms.anouncement} 
                                      />
                              </div>
                            ))
                          }
                         </div>
                    <Button onClick={()=>navigate("/testimonies")}>Testimony Blog</Button>
                    <Button onClick={()=>navigate("/report/auth")}>Report</Button>
                    <Button onClick={()=>navigate("/about")}>About Us</Button>
                    <Button onClick={gotoBethelCast}>Bethel Cast</Button>
                  </nav>
                  }
      
                  <img className="headericon" src={hormwowghradioicon} alt="horemow Ghana"/>
                </div>

                <div className="homebody flex-column2">
                    <div className="motto flex-spacebetween" style={{backgroundImage:`url(${zionbackground})`}}>
                      <div className="mottotext flex-column1">
                        <h2 style={{color:"white"}}>Ghana Must Be Saved!! Ghana Must Be Born Again!!</h2>
                        <p style={{color:"white",fontWeight:"bold",backgroundColor:"#00000050"}}>
                          Welcome to Horemow Ghana Official website.
                          This website is created to harness the activities of the
                          movement, to bring life changing programs and materials for
                          the benefit of the masses... 
                        </p>
                        <button onClick={()=>navigate("/about")}>Read More...</button>
                      </div>
                      <div>
                        <img src={pastorpic1} alt="national coordinator, pastor abraham"/>
                      </div>
                    </div>

                    <div className="broadcastImage-container">
                      <div className="radioHolder" style={{backgroundImage:`url(${background1})`}}>
                        <img  src={hormwowghradioicon} alt="" />
                       <button onClick={radioPage}>Connect to Radio</button>
                      </div>

                      <div className="option-info">
                        <img src={streamSignal} alt="connection signal"/>
                        <h2 style={{fontFamily:"serif"}}>Today Visits</h2>
                        <div className="usageMetrics">
                        <h3 style={{color:"red"}}><strong>Online Radio</strong> {numofusers.length}</h3>
                        <h3 style={{color:"green"}}><strong>On Bethel Cast</strong> {numofzionusers.length}</h3>
                        </div>
                      </div>
                      <div className="zion-meeting" style={{backgroundImage:`url(${zionbackground})`}}>
                      {/* <img src={zionimage} alt="zion meeting"/> */}
                      <HbrBroadcast width={"250px"} height={"250px"} fillColour={"black"}/>
                        <button onClick={gotoBethelCast}>Bethel Cast</button>
                      </div>
                    </div>

                    <div className="broadcastImage-container2">
                      <div className="radioHolder" style={{backgroundImage:`url(${background1})`}}>
                      <img  src={hormwowghradioicon} alt="" />
                      <button onClick={radioPage}>Connect to Radio</button>
                      </div>

                      <div className="zion-meeting" style={{backgroundImage:`url(${zionbackground})`}}>
                      <HbrBroadcast width={"200px"} height={"200px"} fillColour={"black"}/>
                        <button onClick={gotoBethelCast}>Bethel Cast</button>
                      </div>

                      <div className="option-info">
                      <h2 style={{fontFamily:"serif"}}>Today visits</h2>
                      <div className="usageMetrics">
                        <h3 style={{color:"red"}}><strong>Online Radio</strong> {numofusers.length}</h3>
                        <h3 style={{color:"green"}}><strong>On Bethel Cast</strong> {numofzionusers.length}</h3>
                        </div>
                        <img src={streamSignal} alt="connection signal"/>
                      </div>

                    </div>

                </div>

                <FooterInfo/>
        </div>
     );
}
export default Home;